
import { defineComponent, reactive, PropType } from "vue";
import BotaoEditar from "../Botoes/BotaoEditar.vue";
import BotaoAcoes from "../Botoes/BotaoAcoes.vue";
import BotaoExcluir from "../Botoes/BotaoExcluir.vue";
import ActionInterface from "./Interface/ActionInterface";
import BotaoComponent from "../Botoes/BotaoComponent.vue";
import { useRouter } from "vue-router";

type ActionClickHandler = (action: string, id: number) => void;
type DeleteActionHandler = (id: number | string) => void;

export default defineComponent({
  name: "tabela-listagem",
  components: {
    BotaoEditar,
    BotaoAcoes,
    BotaoComponent,
    BotaoExcluir,
  },
  props: {
    mensagemNenhumRegistro: {
      type: String,
      default: "Nenhum Registro Encontrado",
    },
    listas: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    cabecalhoTabela: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    dadosTabela: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      required: false,
    },
    rotaEdit: {
      type: String,
      required: false,
      default: "",
    },
    apenasVisualizar: {
      type: Boolean,
      required: false,
      default: false,
    },
    rotaVisualizar: {
      type: String,
      required: false,
      default: "",
    },
    acoes: {
      type: Array as PropType<ActionInterface[]>,
      required: false,
      default: () => [],
    },
    baseId: {
      type: String as PropType<any>,
      required: false,
      default: "",
    },
    hideAction: {
      type: Boolean,
      required: false,
      default: false,
    },
    deleteAction: {
      type: Object as PropType<DeleteActionHandler>,
      required: false,
    },
    iconClass: {
      type: String,
      required: false,
      default: "bi-pencil-fill",
    },
    btnText: {
      type: String,
      required: false,
      default: "",
    },
    // Nova prop para receber as funções do componente pai
    actions: {
      type: Object as PropType<Record<string, (id: number) => void>>,
      required: false,
      default: () => ({}),
    },
  },
  emits: ["action-click"],
  setup(props, { emit }) {
    const rota = reactive({
      rotaId: "",
    });

    const router = useRouter();

    function goToRoute(id) {
      return router.push({
        name: props.rotaVisualizar,
        params: { baseId: props.baseId, destinoId: id },
      });
    }

    // Nova função para lidar com cliques em ações
    function handleActionClick(action: string, id: number) {
      // Primeiro verifica se existe a função nas props.actions
      if (props.actions && props.actions[action]) {
        props.actions[action](id);
      } else {
        // Se não encontrar, emite um evento para o componente pai
        emit("action-click", { action, id });
      }
    }

    return {
      rota: rota.rotaId,
      goToRoute,
      handleActionClick,
    };
  },
});
